import $ from 'jquery';
import ko from 'knockout';
import SearchPageViewModel from './searchpageviewmodel.js';
import bloomReach from '../shared/bloomreach.js';
import buyItAgain from './buyitagain.js';
import ccChart from '../../colicare/colicarechart.js';
import collapsibleList from './collapsiblelist.js';
import comparison from './productcomparison/comparison.js';
import facets from './facets.js';
import pagination from './pagination.js';
import productRecommendations from './productrecommendations.js';
import productRecommendationsBase from '../recommendations/productrecommendations';
import ratingStarSelector from './ratingstarselector.js';
import searchData from './searchdata.js';
import smartSuggestions from './smartsuggestions.js';
import {productsOnPage} from '../../vendor/googletagmanager/events.js';
import lazyLoadVideo from '../../lazyloadvideo.js';
import {returnsModalEventListener} from '../shared/returnsmodal.js';
import toggleTabView from './tabs';
import searchBanners from './categorysearchbanners.js';
import wishlistToggle from './wishlist/index.js';

const searchPage = {
    _restrictFacetValuesToThreshold: function () {
        $('[data-threshold]').each(function (index, list) {
            var $list = $(list),
                threshold = $list.data('threshold'),
                label = $list.data('label');

            collapsibleList($list, threshold, label);
        });
    },
    _initializeSort: function (handleSortChange) {
        $('.searchSortFilter').on('change', e => handleSortChange(+e.target.value));
    },
    _initializePagination: function (currentPage, handlePagination) {
        $('.pagelist .previous, .pagelist .next')
            .on('click', function (e) {
                e.preventDefault();

                if (e.target.classList.contains('previous')) {
                    handlePagination(currentPage - 1);
                    return;
                }

                if (e.target.classList.contains('next')) {
                    handlePagination(currentPage + 1);
                }
            });

        $('.pagelist')
            .on('click', '.pageNumbers', function (e) {
                e.preventDefault();
            })
            .each(function (index, list) {
                pagination($(list), currentPage, ({page}) => handlePagination(page));
            })
            .removeClass('jsHide');
    },
    _getOpenFacetIDs: function (element) {
        return element
            .children()
            .filter(function (index, element) {
                // Add opened lists
                return $(element).data('opened');
            })
            .map(function (index, element) {
                // Add the ID of this opened list
                return $(element).attr('id');
            });
    },
    _openFacetsByIDs: function (ids) {
        ids.each(function (key, val) {
            $('#' + val).attr('data-opened', 'true');
        });
    },
    _refineSearch: function ({content, isRestoringFacetState}) {
        var $newDom,
            $newProductGrid,
            $newFacets,
            originalFilterCount;      
        
        if (!content) {
            return;
        }

        originalFilterCount = $('#crumbList a').length;

        $newDom = $(content);
        $newProductGrid = $newDom.find('#search-display');

        var ids = this._getOpenFacetIDs($('#facetedSearch')),
            currentFilterCount = $newProductGrid.find('#crumbList a').length;

        if ($newProductGrid.length) {
            $newFacets = $newDom.find('#facetedSearch');
            $('#search-display').replaceWith($newProductGrid);
            $('#facetedSearch').replaceWith($newFacets);

            this._updatePage();
            this._updateFilterStatus(originalFilterCount, currentFilterCount);
            this._openFacetsByIDs(ids);
            this._restrictFacetValuesToThreshold();

            if (!isRestoringFacetState) {                
                $('html, body').animate({
                    scrollTop: $('#search-display').offset().top
                });
            }

            if ($('#product-grid').length && $('#compareBar').length) {
                this._initializeComparisonChart();
            }
        } 
    },
    _updateFilterStatus: function (originalFilterCount, currentFilterCount) {
        $('#searchCrumbStatus').html(
            originalFilterCount < currentFilterCount
                ? 'Filter has been added to your selection'
                : 'Filter has been removed from your selection'
        );
    },
    _initializeViewAll: function (handleViewAll) {
        let id = 0;

        $('.pageListShowAll')
            .each(function (index, element) {
                const labelledby = `viewall-${id}`;

                element.id = labelledby;
                element.setAttribute('aria-labelledby', `${labelledby} h1Title`);
                id++;
            })
            .on('click', function (e) {
                e.preventDefault();

                if (typeof handleViewAll === 'function') { 
                    handleViewAll();
                }
            });
    },
    _shouldHideNewProductTags: function (categoryId) {
        var EXCLUDED_CATEGORY_IDS = [
            '811',
            '421',
            '283',
            '763',
            '772',
            '695',
            '764',
            '286',
            '1603',
            '539',
            '540',
            '541',
            '698',
            '699',
            '768',
            '1213',
            '1303',
            '1666',
            '1854',
            '1855',
            '1856',
            '1857',
            '1858',
            '1859',
            '1860',
            '1861',
            '1862',
            '1863',
            '1865',
            '1866',
            '1867',
            '1869',
            '1870',
            '1871',
            '1872',
            '1873',
            '1874',
            '1875',
            '1876',
            '1877',
            '1878',
            '1879',
            '1880',
            '1881',
            '1882',
            '1883',
            '1884',
            '1885',
            '1886',
            '1887'
        ];

        return EXCLUDED_CATEGORY_IDS.includes(categoryId);
    },
    _showSpecificPerksMessaging: function () {
        var hasPromo = smartPak.cdProfileCookie.hasSmartPerksPromo,
            isEligible = smartPak.smartPrimeCookie.PerksEligible,
            $active = $('.active'),
            $inactive = $('.inactive'),
            $ineligible = $('.ineligible');

        if (hasPromo === 'True' && isEligible === 'True') {
            $active.removeClass('jsHide');
        }

        if (hasPromo !== 'True' && isEligible === 'True') {
            $inactive.removeClass('jsHide');
        }

        if (isEligible !== 'True') {
            $ineligible.removeClass('jsHide');
        }
    },
    _getCategorySearchTerm: function () {
        const categoryBanner = document.querySelector('.cat-banner-header');
        const pageName = document.querySelector('#categoryTitle #h1Title');
        
        return pageName?.innerText || categoryBanner?.innerText || '';
    },
    _getProductsFromPage: function () {
        return Array.from(document.querySelectorAll('#product-grid [data-productid]')).map(element => {
            return {
                name: element.dataset.productName.trim(),
                productClassId: +element.dataset.productid,
                itemId: +element.dataset.productid + 10000
            };
        });
    },
    _getProductIdsFromPage: function () {
        return $.map($('#product-grid').find('[data-productid]'), function (element) {
            return +element.dataset.productid;
        });
    },
    _setRecommendations: function (response, ids) {
        productRecommendations.init(response.supplementWizardResults);
        if (smartPak.cdProfileCookie && smartPak.cdProfileCookie.qualifiesForSuggestions) {
            smartSuggestions.init(response.smartSuggestions, ids);
        }
    },
    _wishlistToggle: function () {
        wishlistToggle();
    },
    _updatePage: function () {
        var ids,
            products;

        const $gridInterrupters = document.querySelectorAll('#product-grid .interrupter [data-ids][data-title]');

        if ($gridInterrupters) {
            import('./gridinterrupters.js').then(({ default: gridinterrupters }) => gridinterrupters([...$gridInterrupters]));
        }

        this._initializeSort(value => this.dataManager.setSort(value));
        this._initializePagination(this.dataManager.getPageNumber(), value => this.dataManager.setPageNumber(value));
        this._initializeViewAll(() => {
            const MAX_SIZE = 200;
            this.dataManager.setSize(MAX_SIZE);
        });
        facets.init({
            activeFacetNames: this.dataManager.getActiveFacetNames(),
            handleFacetAdd: data => this.dataManager.addFacet(data),
            handleFacetRemove: data => this.dataManager.removeFacet(data),
        });
        ratingStarSelector.init();
        smartPak.recentlyViewedProducts._waitForContainer(
            '.searchReviewStars',
            smartPak.recentlyViewedProducts._showBvReviewStars
        );
        ccChart.updateChartPrices();
        this._showSpecificPerksMessaging();


        const params = new URLSearchParams(location.search);
        const initialHash = params.get('type') === 'content-term' ? '#bloomreachContentResults' : undefined;

        toggleTabView(document.querySelectorAll('.productCompareResults'), initialHash);

        if (this._shouldHideNewProductTags(this.dataManager.getCategoryId())) {
            $('.new-product-badge').hide();
        }

        products = this._getProductsFromPage();

        if (this.dataManager.isCategory() || this.dataManager.isKeyword()) {
            const term = this.dataManager.isCategory() ? this._getCategorySearchTerm() : this.dataManager.getKeywordSearchTerm();
            const searchPageViewModel = new SearchPageViewModel(term, products);

            ko.applyBindings(searchPageViewModel, document.getElementById('bloomreachContentResults'));
        }

        this._wishlistToggle();

        productsOnPage(products);

        ids = products.map(product => product.productClassId);

        if (ids && ids.length) {
            Promise.all([productRecommendationsBase.get(ids), buyItAgain.getProductResults()]).then(responses => {
                this._setRecommendations(responses[0], ids);
                buyItAgain.processResults(responses[1]);
            });
        }

        if (typeof this.onPageUpdate === 'function') {
            this.onPageUpdate();
        }
    },
    _initializeComparisonChart: function () {
        comparison();
    },
    init: function (onPageUpdate) {
        const handleContentChange = ({content, isRestoringFacetState}) => this._refineSearch({content, isRestoringFacetState});
        
        this.dataManager = searchData(window.requestData, handleContentChange);

        this.onPageUpdate = onPageUpdate;
        this._updatePage();
        this._restrictFacetValuesToThreshold();

        bloomReach.init(document.querySelector('.BRRelatedProducts'), '.br-sf-widget', 4);

        if (window.searchBannersByCategory) {
            searchBanners(window.searchBannersByCategory, smartPak.smartPrimeCookie?.PerksEligible === 'True');
        }

        if (window.searchBannersByTerm) {
            searchBanners(window.searchBannersByTerm, smartPak.smartPrimeCookie?.PerksEligible === 'True');
        }

        if ($('#product-grid').length && $('#compareBar').length) {
            this._initializeComparisonChart();
        }

        lazyLoadVideo();
        returnsModalEventListener();       
    }
};




export default searchPage;
